/*
 * KCONV USP-rij – berekent client-side de verwachte leverdatum.
 * - Werkdagen (weekend overslaan) + cutoff-tijd in de winkeltijdzone.
 * - Locale-afhankelijke datumnotatie (Intl).
 * - Toont USP 1-A (datum) of USP 1-B (fallback) op basis van de
 *   voorraad van de geselecteerde variant (stock-map).
 */
(function () {
  'use strict';

  function isWeekend(d) {
    var day = d.getDay();
    return day === 0 || day === 6;
  }

  // Huidige tijd in een specifieke tijdzone benaderen.
  function nowInTz(tz) {
    try {
      var str = new Date().toLocaleString('en-US', { timeZone: tz });
      var d = new Date(str);
      if (!isNaN(d.getTime())) return d;
    } catch (e) { /* val terug op lokale tijd */ }
    return new Date();
  }

  function computeDeliveryDate(workdays, cutoff, tz) {
    var now = nowInTz(tz);
    var parts = (cutoff || '17:00').split(':');
    var ch = parseInt(parts[0], 10);
    var cm = parseInt(parts[1], 10) || 0;
    if (isNaN(ch)) ch = 17;

    var cutoffPassed =
      now.getHours() > ch || (now.getHours() === ch && now.getMinutes() >= cm);

    // Verzenddag bepalen (vandaag als voor cutoff + werkdag, anders volgende werkdag).
    var dispatch = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (cutoffPassed) dispatch.setDate(dispatch.getDate() + 1);
    while (isWeekend(dispatch)) dispatch.setDate(dispatch.getDate() + 1);

    // Levering = verzenddag + N werkdagen (weekend overslaan).
    var delivery = new Date(dispatch);
    var added = 0;
    var n = parseInt(workdays, 10);
    if (isNaN(n) || n < 0) n = 1;
    while (added < n) {
      delivery.setDate(delivery.getDate() + 1);
      if (!isWeekend(delivery)) added++;
    }
    return { now: now, delivery: delivery };
  }

  function formatDelivery(el) {
    var workdays = el.getAttribute('data-workdays');
    var cutoff = el.getAttribute('data-cutoff') || '17:00';
    var tz = el.getAttribute('data-tz') || 'Europe/Amsterdam';
    var locale = el.getAttribute('data-locale') || 'nl';
    var todayWord = el.getAttribute('data-today') || 'vandaag';
    var tomorrowWord = el.getAttribute('data-tomorrow') || 'morgen';

    var res = computeDeliveryDate(workdays, cutoff, tz);
    var today = new Date(
      res.now.getFullYear(),
      res.now.getMonth(),
      res.now.getDate()
    );
    var diffDays = Math.round((res.delivery - today) / 86400000);

    var dateStr;
    try {
      dateStr = res.delivery.toLocaleDateString(locale, {
        day: 'numeric',
        month: 'long',
      });
    } catch (e) {
      dateStr = res.delivery.getDate() + '/' + (res.delivery.getMonth() + 1);
    }

    var label;
    if (diffDays <= 0) {
      label = todayWord;
    } else if (diffDays === 1) {
      label = tomorrowWord + ' (' + dateStr + ')';
    } else {
      var weekday;
      try {
        weekday = res.delivery.toLocaleDateString(locale, { weekday: 'long' });
      } catch (e) {
        weekday = '';
      }
      label = weekday ? weekday + ' ' + dateStr : dateStr;
    }

    var valueEl = el.querySelector('[data-kconv-usp-eta-value]');
    if (valueEl) valueEl.textContent = label;
  }

  function getStockMap(el) {
    try {
      return JSON.parse(el.getAttribute('data-stock-map') || '{}');
    } catch (e) {
      return {};
    }
  }

  function applyStock(row, variantId) {
    var etaEl = row.querySelector('[data-kconv-usp-eta]');
    var fbEl = row.querySelector('[data-kconv-usp-eta-fallback]');
    if (!etaEl) return;
    var map = getStockMap(etaEl);
    var inStock = variantId != null && map[String(variantId)] === true;
    if (inStock) {
      etaEl.hidden = false;
      if (fbEl) fbEl.hidden = true;
      formatDelivery(etaEl);
    } else {
      etaEl.hidden = true;
      if (fbEl) fbEl.hidden = false;
    }
  }

  function formatVisible() {
    document.querySelectorAll('.kconv-usp-row [data-kconv-usp-eta]').forEach(
      function (etaEl) {
        if (!etaEl.hidden) formatDelivery(etaEl);
      }
    );
  }

  function onVariantChange(e) {
    var variant = e.detail && e.detail.variant;
    document.querySelectorAll('.kconv-usp-row').forEach(function (row) {
      if (variant && variant.id != null) {
        applyStock(row, variant.id);
      } else {
        formatVisible();
      }
    });
  }

  function init() {
    formatVisible();
    // De theme kan de sectie-DOM opnieuw renderen bij een variant-wissel;
    // daarom herbevragen we de DOM in de globale listener (één keer koppelen).
    if (!document.body.dataset.kconvUspBound) {
      document.body.dataset.kconvUspBound = '1';
      document.addEventListener('variant:changed', onVariantChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
